import { render, staticRenderFns } from "./OpenBem.vue?vue&type=template&id=6f91aedc&"
import script from "./OpenBem.vue?vue&type=script&lang=js&"
export * from "./OpenBem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports